var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
import _imports_0 from '../assets/not_found.png';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "w-full flex flex-col items-center space-y-5 py-48"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "h-32 mx-auto"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "text-xl font-semibold text-center" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "No calendar found!"),
    /*#__PURE__*/ _createElementVNode("p", null, " Please create a new one or ask the admin to assign you to an existing calendar ")
], -1);
import CalendarView from '@/components/calendar/CalendarView.vue';
import { convertClassEvents, convertEvents } from '@/helper/helper';
import { setupVueI18n } from '@/plugin/vue-i18n';
import { CalendarEventService } from '@/service/CalendarEventService';
import { setLocationId } from '@/states/view_appointment';
import { getLoggedInUserTimezone } from '@/utils/timezones';
import { UIButton } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import _ from 'lodash';
import moment from 'moment-timezone';
import { computed, onMounted, provide, ref, toRaw, watchEffect } from 'vue';
import calendarWidgetStates from '../helper/calendarWidgetStates';
import '../index.css';
import BookAppointment from './BookAppointment.vue';
import ViewAppointment from './ViewAppointment.vue';
import { USER_ROLES } from '@/helper/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalendarPage',
    props: {
        userId: String,
        locationId: String,
        timezone: String,
        calendars: {
            type: Array,
            default: () => [],
        },
        groups: {
            type: Array,
            default: () => [],
        },
        users: {
            type: Array,
            default: () => [],
        },
        router: Object,
        route: Object,
        data: null,
    },
    setup(__props) {
        const props = __props;
        provide('locale', props.data.locale);
        setupVueI18n(props.data.locale);
        const router = props.router;
        const isLoading = ref(false);
        const showViewAppointmentModal = ref(false);
        const viewAppointmentModalData = ref(null);
        const bookAppointmentdata = ref(null);
        const showBookAppointmentModal = ref(false);
        const usersData = ref([]);
        const calendarsData = ref([]);
        const groupsData = ref([]);
        let eventsMapping = {};
        function updateEventOnDrag(eventId, calendarId, ignoreFreeSlotValidation = false, locationId, contactId, title, calendarNotes, startTime, endTime, selectedTimezone, appointmentStatus, ignoreDateRange = true, toNotify = false, source, channel, meetingLocationType, assignedUserId) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (!eventId)
                        return;
                    isLoading.value = true;
                    const response = yield CalendarEventService.updateAppointment(eventId, {
                        calendarId: calendarId,
                        ignoreFreeSlotValidation: ignoreFreeSlotValidation,
                        locationId: locationId,
                        contactId: contactId,
                        title: title,
                        calendarNotes: calendarNotes,
                        startTime: startTime,
                        endTime: endTime,
                        selectedTimezone: selectedTimezone,
                        appointmentStatus: appointmentStatus,
                        ignoreDateRange: ignoreDateRange,
                        toNotify: toNotify,
                        source: source,
                        channel: channel,
                        meetingLocationType: meetingLocationType,
                        assignedUserId: assignedUserId,
                    });
                    if (response.data) {
                        isLoading.value = false;
                        calendarWidgetStates.refreshEvents =
                            calendarWidgetStates.refreshEvents + 1;
                    }
                }
                catch (e) {
                    calendarWidgetStates.refreshEvents = calendarWidgetStates.refreshEvents + 1;
                }
            });
        }
        const loggedInUserTimezone = computed(() => {
            const loggedInUser = props.data.loggedInUserInfo;
            const _loggedInUserTimezone = getLoggedInUserTimezone(loggedInUser, props.locationId);
            return _loggedInUserTimezone || props.timezone;
        });
        const targetTimezone = computed(() => {
            const calendarData = props.data;
            const isTimezoneConfigEnabled = calendarData.isTimezoneConfigEnabled;
            return isTimezoneConfigEnabled ? loggedInUserTimezone.value : props.timezone;
        });
        function fetchDataAndSetEvents(locationId, calendarId, groupId, userId, start, end) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    calendarWidgetStates.filterValue = 'All';
                    const filterParams = Object.assign(Object.assign(Object.assign({}, (calendarWidgetStates.activeView == 'calendar' && {
                        calendarId: calendarId,
                    })), (calendarWidgetStates.activeView == 'group' && { groupId: groupId })), (calendarWidgetStates.activeView == 'user' && { userId: userId }));
                    const { data } = yield CalendarEventService.getCalendarEvents({
                        filter: Object.assign(Object.assign({ locationId: locationId }, filterParams), { startTime: moment(start).valueOf() + '', endTime: moment(end).valueOf() + '' }),
                        includeAll: true,
                        timezone: targetTimezone.value,
                    });
                    const eventsArray = convertEvents(data.events, targetTimezone.value, calendarWidgetStates.activeView == 'user'
                        ? userId
                        : calendarWidgetStates.activeView == 'group'
                            ? groupId
                            : calendarId, calendarWidgetStates.activeView == 'user'
                        ? usersData.value
                        : calendarWidgetStates.activeView == 'group'
                            ? groupsData.value
                            : calendarsData.value);
                    if (calendarId) {
                        eventsMapping[calendarId] = eventsArray;
                    }
                    else if (groupId) {
                        eventsMapping[groupId] = eventsArray;
                    }
                    else if (userId) {
                        eventsMapping[userId] = eventsArray;
                    }
                }
                catch (e) {
                    isLoading.value = false;
                }
            });
        }
        watchEffect(() => __awaiter(this, void 0, void 0, function* () {
            const calendarIds = calendarWidgetStates.calendarIds;
            const groupIds = calendarWidgetStates.groupIds;
            const userIds = calendarWidgetStates.userIds;
            const eventsMappingKeys = Object.keys(eventsMapping);
            const refresh = calendarWidgetStates.refreshEvents;
            eventsMappingKeys.forEach((key) => {
                if (!calendarIds.includes(key)) {
                    delete eventsMapping[key];
                    calendarWidgetStates.events = Object.values(eventsMapping).flat();
                }
                if (!groupIds.includes(key)) {
                    delete eventsMapping[key];
                    calendarWidgetStates.events = Object.values(eventsMapping).flat();
                }
                if (!userIds.includes(key)) {
                    delete eventsMapping[key];
                    calendarWidgetStates.events = Object.values(eventsMapping).flat();
                }
            });
            if (refresh) {
                const { locationId, activeView, calendarIds, groupIds, userIds, start, end, } = calendarWidgetStates;
                const fetchDataAndSetEventsForIds = (calendarId, groupId, userId) => {
                    if (calendarId || groupId || userId) {
                        return fetchDataAndSetEvents(locationId, calendarId, groupId, userId, start, end);
                    }
                };
                const promises = [];
                switch (activeView) {
                    case 'calendar':
                        (calendarIds === null || calendarIds === void 0 ? void 0 : calendarIds.length) &&
                            (calendarIds === null || calendarIds === void 0 ? void 0 : calendarIds.forEach(calendarId => {
                                promises.push(fetchDataAndSetEventsForIds(calendarId, null, null));
                            }));
                        break;
                    case 'group':
                        (groupIds === null || groupIds === void 0 ? void 0 : groupIds.length) &&
                            (groupIds === null || groupIds === void 0 ? void 0 : groupIds.forEach(groupId => {
                                promises.push(fetchDataAndSetEventsForIds(null, groupId, null));
                            }));
                        break;
                    case 'user':
                        (userIds === null || userIds === void 0 ? void 0 : userIds.length) &&
                            (userIds === null || userIds === void 0 ? void 0 : userIds.forEach(userId => {
                                promises.push(fetchDataAndSetEventsForIds(null, null, userId));
                            }));
                        break;
                    default:
                        break;
                }
                if (promises.length > 0) {
                    isLoading.value = true;
                    yield Promise.all(promises).then(() => {
                        const allEvents = Object.values(eventsMapping).flat();
                        calendarWidgetStates.events = convertClassEvents(allEvents, calendarsData.value, calendarWidgetStates.activeView);
                        isLoading.value = false;
                    });
                }
            }
        }));
        watchEffect(() => {
            viewAppointmentModalData.value = JSON.stringify(calendarWidgetStates.viewAppointmentModal.data);
            showViewAppointmentModal.value =
                calendarWidgetStates.viewAppointmentModal.show;
        });
        watchEffect(() => {
            var _a, _b, _c, _d;
            if (calendarsData.value.length > 0) {
                let selectedCalendar = calendarsData.value.find(cal => cal.id == _.last(calendarWidgetStates.calendarIds)) || calendarsData.value[0];
                if (calendarWidgetStates.resourceDragData.type === 'calendar') {
                    selectedCalendar = calendarsData.value.find(cal => cal.id == calendarWidgetStates.resourceDragData.id);
                }
                const filteredCalendarsForUsers = calendarWidgetStates.activeView === 'user' &&
                    calendarWidgetStates.resourceDragData.id
                    ? props.data.calendars.filter(cal => {
                        var _a;
                        return (_a = cal === null || cal === void 0 ? void 0 : cal.teamMembers) === null || _a === void 0 ? void 0 : _a.map(i => i === null || i === void 0 ? void 0 : i.userId).includes(calendarWidgetStates.resourceDragData.id);
                    })
                    : props.data.calendars;
                bookAppointmentdata.value = Object.assign(Object.assign({}, bookAppointmentdata.value), { startTime: calendarWidgetStates.bookAppointmentModal.startTime, endTime: calendarWidgetStates.bookAppointmentModal.endTime, calendarId: calendarWidgetStates.resourceDragData.id ||
                        _.last(calendarWidgetStates.calendarIds) ||
                        selectedCalendar.id, isCalendarEvent: calendarWidgetStates.bookAppointmentUsingDrag, isUserCalendar: calendarWidgetStates.activeView == 'user' ? true : false, userId: calendarWidgetStates.resourceDragData.id ||
                        _.last(calendarWidgetStates.userIds) ||
                        props.userId, isV2CalendarSelected: (selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.calendarType) === 'event', calendarProviderId: calendarWidgetStates.activeView == 'group'
                        ? ((_b = (_a = calendarsData.value) === null || _a === void 0 ? void 0 : _a.filter(x => (x === null || x === void 0 ? void 0 : x.providerId) === _.last(calendarWidgetStates.groupIds))) === null || _b === void 0 ? void 0 : _b.length) > 0
                            ? _.last(calendarWidgetStates.groupIds)
                            : null
                        : null, appointmentIds: selectedCalendar.appointmentIds || null, webinarId: selectedCalendar.webinarId || null, calendars: filteredCalendarsForUsers, source: 'calendar_page' });
                const isSelectedCalendarActive = (_c = calendarsData.value.find(cal => { var _a; return (cal === null || cal === void 0 ? void 0 : cal.id) === ((_a = bookAppointmentdata.value) === null || _a === void 0 ? void 0 : _a.calendarId); })) === null || _c === void 0 ? void 0 : _c.isActive;
                const getLastActiveCalendar = calendarWidgetStates.calendarIds.length > 1
                    ? calendarWidgetStates.calendarIds
                        .slice()
                        .reverse()
                        .find(calendarId => {
                        var _a;
                        return (_a = calendarsData.value.find(cal => (cal === null || cal === void 0 ? void 0 : cal.id) === calendarId)) === null || _a === void 0 ? void 0 : _a.isActive;
                    })
                    : null;
                bookAppointmentdata.value = Object.assign(Object.assign({}, bookAppointmentdata.value), { calendarId: isSelectedCalendarActive
                        ? (_d = bookAppointmentdata.value) === null || _d === void 0 ? void 0 : _d.calendarId
                        : getLastActiveCalendar });
                showBookAppointmentModal.value =
                    calendarWidgetStates.bookAppointmentModal.show;
            }
        });
        function initiatePage() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                eventsMapping = {};
                const loggedInUserForNonAdmin = [];
                const loggedUser = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo;
                loggedInUserForNonAdmin.push(toRaw(loggedUser));
                calendarWidgetStates.events = [];
                bookAppointmentdata.value = props.data;
                calendarWidgetStates.userId = props.userId;
                calendarWidgetStates.timezone = props.timezone;
                calendarWidgetStates.startDayOfWeek = props.data.startDayOfWeek;
                const isAdmin = (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.role) === USER_ROLES.ADMIN;
                const assignedDataOnly = !isAdmin && ((_b = loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.permissions) === null || _b === void 0 ? void 0 : _b.assignedDataOnly) === true;
                if (assignedDataOnly) {
                    const assignedCalendarId = loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.userCalendar[props.locationId];
                    calendarsData.value = props.calendars.filter(c => assignedCalendarId === c.id ||
                        (c.teamMembers &&
                            c.teamMembers.find(x => x.selected && x.userId === (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.id))));
                    usersData.value = loggedInUserForNonAdmin;
                }
                else {
                    calendarsData.value = props.calendars;
                    usersData.value = props.users;
                }
                const groupIds = [
                    ...new Set(calendarsData.value.map(calendar => calendar.providerId || calendar.groupId)),
                ];
                groupsData.value =
                    (loggedUser === null || loggedUser === void 0 ? void 0 : loggedUser.role) === 'admin'
                        ? props.groups
                        : props.groups.filter(x => groupIds.includes(x.id));
            });
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            calendarWidgetStates.isCalendarLoading = true;
            initiatePage();
            calendarWidgetStates.isCalendarLoading = false;
            setLocationId(props.locationId);
        }));
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e;
            return (_openBlock(), _createElementBlock("div", null, [
                (calendarsData.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (!_unref(calendarWidgetStates).isCalendarLoading)
                            ? (_openBlock(), _createBlock(CalendarView, {
                                key: 0,
                                userId: __props.userId,
                                timezone: targetTimezone.value,
                                calendars: calendarsData.value,
                                groups: groupsData.value,
                                users: usersData.value,
                                locationId: __props.locationId,
                                router: _unref(router),
                                isLoading: isLoading.value,
                                data: props.data,
                                "update-event-on-drag": updateEventOnDrag
                            }, null, 8, ["userId", "timezone", "calendars", "groups", "users", "locationId", "router", "isLoading", "data"]))
                            : _createCommentVNode("", true),
                        (showViewAppointmentModal.value)
                            ? (_openBlock(), _createBlock(ViewAppointment, {
                                key: 1,
                                data: viewAppointmentModalData.value,
                                router: _unref(router),
                                route: __props.route,
                                "show-modal": showViewAppointmentModal.value,
                                "on-cancel-click": (event) => {
                                    _unref(calendarWidgetStates).viewAppointmentModal.show = false;
                                    _unref(calendarWidgetStates).viewAppointmentModal.data = {};
                                    if (event) {
                                        _unref(calendarWidgetStates).refreshEvents =
                                            _unref(calendarWidgetStates).refreshEvents + 1;
                                    }
                                },
                                locale: props.data.locale
                            }, null, 8, ["data", "router", "route", "show-modal", "on-cancel-click", "locale"]))
                            : _createCommentVNode("", true),
                        (showBookAppointmentModal.value && bookAppointmentdata.value.calendars)
                            ? (_openBlock(), _createBlock(BookAppointment, {
                                key: 2,
                                route: __props.route,
                                router: _unref(router),
                                "on-cancel-click": (event) => {
                                    _unref(calendarWidgetStates).bookAppointmentModal = {
                                        show: false,
                                        data: {},
                                        isBlockedSlot: false,
                                        startTime: '',
                                        endTime: '',
                                    };
                                    bookAppointmentdata.value = Object.assign(Object.assign({}, props.data), { show: false, data: {}, isBlockedSlot: false, startTime: '', endTime: '' });
                                    _unref(calendarWidgetStates).bookAppointmentUsingDrag = false;
                                    _unref(calendarWidgetStates).resourceDragData = { type: '', id: '', isActive: false };
                                    if (event) {
                                        _unref(calendarWidgetStates).refreshEvents =
                                            _unref(calendarWidgetStates).refreshEvents + 1;
                                    }
                                },
                                "show-modal": showBookAppointmentModal.value && ((_b = (_a = bookAppointmentdata.value) === null || _a === void 0 ? void 0 : _a.calendars) === null || _b === void 0 ? void 0 : _b.length) > 0,
                                data: JSON.stringify(bookAppointmentdata.value),
                                locale: props.data.locale
                            }, null, 8, ["route", "router", "on-cancel-click", "show-modal", "data", "locale"]))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _hoisted_3,
                        _hoisted_4,
                        ((_e = (_d = (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.loggedInUserInfo) === null || _d === void 0 ? void 0 : _d.permissions) === null || _e === void 0 ? void 0 : _e.settingsEnabled)
                            ? (_openBlock(), _createBlock(_unref(UIButton), {
                                key: 0,
                                id: "go-to-calendar-settings",
                                type: "primary",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(router).push({ name: 'calendar-settings__default' })), ["prevent"]))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(" Go to calendar settings ")
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]))
            ]));
        };
    }
});
